const setupFilters = () => {
  $('.form_filter').on('change', function () {
    $(this).closest('form').submit();
  });
};
export default setupFilters;



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/common/filters.js